import { PARTNER_WHITELIST_STATUS } from '../actions/partnerMigration';
import { MACPartnerMigrationAction, MACPartnerMigrationState } from '../models';
import Progress from 'redux-progress';

export const initialState = {
  partnerWhitelistStatus: Progress.none,
};

export default (
  state: MACPartnerMigrationState = initialState,
  action: MACPartnerMigrationAction,
): MACPartnerMigrationState => {
  if (action.type === PARTNER_WHITELIST_STATUS) {
    return {
      ...state,
      partnerWhitelistStatus: action.progress,
    };
  }

  return state;
};
